import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=6c053cb0&scoped=true&"
import script from "./Retailer.vue?vue&type=script&lang=js&"
export * from "./Retailer.vue?vue&type=script&lang=js&"
import style0 from "./Retailer.vue?vue&type=style&index=0&id=6c053cb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c053cb0",
  null
  
)

export default component.exports